import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";
import { DuChiriiModel, SistemImpozitareChirii } from "../client-forms.models";
import { ClientFormsService } from "../client-forms.service";

@Component({
    selector: 'chirie-du-pfa-2024',
    templateUrl: 'chirie-du-pfa-2024.component.html',
    styleUrls: ['chirie-du-pfa-2024.component.scss'],
    standalone: false
})
export class ChirieDuPFA2024Component implements OnInit {
    @Input() public index: number;
    @Input() public model: DuChiriiModel;
    @Input() public year: number;
    @Input() public isReadOnly: boolean;

    @Output() public delete = new EventEmitter();

    // view child
	@ViewChild('chirieForm') public chirieForm: NgForm;

    //subscription
    private isFormTouchedSubscription: Subscription;
    
    //model
    public sistemImpozitareList: any[];
    public sistemImpozitareRealizatList: any[] = [
        { value: SistemImpozitareChirii.CoteForfetare, name: this.clientFormsService.sistemImpozitareChiriiDisplay(SistemImpozitareChirii.CoteForfetare) }];
    
    constructor(private clientFormsService: ClientFormsService) { }
    
    ngOnInit(): void {
        this.sistemImpozitareList = this.sistemImpozitareRealizatList;
        this.isFormTouchedSubscription = this.clientFormsService.isFormTouched.subscribe(this.onFormTouched.bind(this));
    }

    ngOnDestroy(): void {
        if (this.isFormTouchedSubscription) { this.isFormTouchedSubscription.unsubscribe(); this.isFormTouchedSubscription = null; }
    }

    private onFormTouched() {
        if (this.chirieForm != undefined && this.chirieForm.form != undefined) {
            this.chirieForm.form.markAllAsTouched();
        }
    }

    public getMinDate(): Date {
        return new Date(this.year, 0, 1);
    }

    public getMaxDate(): Date {
        return new Date(this.year, 11, 31);
    }
    
    public validateDataActivitate(value: Date) {
		if (value && (value < this.getMinDate() || value > this.getMaxDate())) {
			return `Data trebuie să fie în interiorul anului de referință: ${this.year}`;
		}

		return true;
	}
}